import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './OrderConfirmationPage.css';
import { formatDate } from '../utils/dateUtils';

const OrderConfirmationPage: React.FC = () => {
  const location = useLocation();
  const orderData = location.state || {};
  
  // Format date if available
  const formattedDate = orderData.pickupDate 
    ? formatDate(new Date(orderData.pickupDate)) 
    : 'Hamarosan értesítünk';
  
  // Use the real order ID from backend or fallback to a random one for demo
  const orderId = orderData.orderId || Math.floor(1000 + Math.random() * 9000);
  
  return (
    <div className="order-confirmation-page">
      <div className="confirmation-container">
        <div className="confirmation-icon">✓</div>
        
        <h1>Köszönjük a rendelésedet!</h1>
        
        <p className="confirmation-message">
          Rendelésedet sikeresen rögzítettük. A rendelés részleteiről e-mailben küldünk tájékoztatást.
        </p>
        
        <div className="order-details">
          <p className="order-number">
            <span>Rendelés száma:</span> #{orderId}
          </p>
          
          {orderData.customerName && (
            <p className="customer-name">
              <span>Megrendelő neve:</span> {orderData.customerName}
            </p>
          )}
          
          {orderData.pickupDate && (
            <p className="pickup-date">
              <span>Átvétel dátuma:</span> {formattedDate}
            </p>
          )}
          
          {orderData.totalAmount && (
            <p className="total-amount">
              <span>Fizetendő összeg:</span> {orderData.totalAmount.toLocaleString('hu-HU')} Ft
            </p>
          )}
          
          <p className="order-info">
            A rendelés feldolgozása folyamatban van. Az átvételkor a helyszínen kell fizetned.
          </p>
        </div>
        
        <div className="confirmation-actions">
          <Link to="/" className="btn btn-primary">Vissza a főoldalra</Link>
          <Link to="/products" className="btn btn-secondary">További termékek böngészése</Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
